import { checkImportExact, clearExistingScheduledImports} from './import';
import { getCookie, getCurrentUser, enableUpdateImports, updateUserLastAction } from './utils';

// Handles exactonline import execution on the server
export async function handleImport(row, updateStatus){
  // await checkImportExact(data[id].entiteit, data[id].year, data[id].budget_scenario, office);
  try {
    handleStatus(updateStatus, true);

    const response = await fetch('/afas/executeImport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json' 
      },
      body: JSON.stringify({
        entiteit: row.entiteit,
        year: row.year,
        budget_scenario: row.budget_scenario,
        office: row.office,
        user_id: await getCurrentUser(),
      }),
    });
    if (response.ok) {
      await enableUpdateImports();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    handleStatus({"text": "Error!", "progress": 1, "status": 0});
  }
}
export async function getAfasCompany(appUser){

  if(appUser.integration_afas){
    var metaInfo = await getMetaInfo(appUser.integration_afas);

    return metaInfo;
  }
  else{
    return false;
  }
}
async function getMetaInfo(integration_afas){
    var response = await fetch('/afas/getMetaInfo?integration_afas='+integration_afas, {
      method: 'GET',
    }); 
    var responseData = await response.json();

    if(responseData.info){
      return responseData;
    }
    else{
      return false;
    }
  }
export async function getAdministrations(){
  var config = await getAfasConfig(await getCurrentUser());
  const response = await fetch('/afas/getAdministration', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(config)
  });
  if (response.ok) {
    const responseData = await response.json();

    if(responseData){
      var administrations = [];
      for(var i = 0; i < responseData.length; i++){
        var adminObj = {"Description": responseData[i].description, "Code": responseData[i].code, "type":'administration'};
        administrations.push(adminObj);
        await updateImportAfasByOffice(responseData[i].code);
      };

      return administrations;
    }
  }
}

async function findByDivision(office){
  var response = await fetch('/import_afas/getListArray?division='+office);
  if(response.ok){
    var responseData = response.json();
    return responseData;
  }
}

// Update import exact factview and exactonline tokens
export async function updateImportAfasByOffice(office){
  var imp = await findByDivision(office);
  if(imp){
    for(var i = 0; i < imp.length; i++){
      await fetch('/import_afas/updateImportAfasTokens', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: imp[i].id,
          factview_access: getCookie('factview_access'),
          factview_refresh: getCookie('factview_refresh'),
          exact_access: getCookie('exact_access'),
          exact_refresh: getCookie('exact_refresh'),
        }),
      });  
   }
  }
  
}
export async function getAfasConfig(currentUser){
  try{
    const response = await fetch('https://api2.factview.nl/user/getAfas?currentUser='+currentUser, {
      method: 'GET',
      headers: {
        'authorization': 'Bearer '+ getCookie("factview_access"),
        'Content-Type': 'application/json',
        'Accept': 'application/json' 
      }
    });

    if (response.ok) {
      const responseData = await response.json();

      if(responseData){
        
        return responseData;
      }
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}
export async function getImportAfas(mvLink){
  try{
    const response = await fetch('/afas/getImportAfas', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        afas_link: mvLink
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}
export async function createImport(importConfig){
  try{
    updateUserLastAction();
    const response = await fetch('/afas/createImportAfas', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(importConfig),
    })
    if (response.ok) {
      const responseData = await response.json();
      
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}



//Submits import afas updates/changes
export async function updateImportAfas(id, openingBalance, ignoreYearEnd){
  try{
    const response = await fetch('/import_afas/updateImportAfas', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id,
        openingBalance: openingBalance,
        ignoreYearEnd: ignoreYearEnd,
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

// Delete import exact by id
export async function deleteImportAfas(id){
  try { 
    // var importData = data.filter(item => item.id == id)[0];
    const importResponse = await fetch('/import_afas/getById?id='+id);
    if(importResponse.ok){
      const importData = await importResponse.json();
      await clearExistingScheduledImports({"import_type": "afas", "entiteit": importData["entiteit"], "year": importData["year"],"office": importData["office"], "budget_scenario": importData["budget_scenario"]});
   
      const response = await fetch('/import_afas/deleteImportAfas?id='+id);
      if (response.ok) {
      const responseData = await response.json();
      
      if(responseData){
      }
    }
    
    }
  } catch (error) {
    console.error('Error deleting data:', error);
  }
}

// Handles fetching status updates from the server
async function handleStatus(updateStatus, init){
  try{
    if(init){
      await fetch('/afas/resetStatus');
      setTimeout(function(){
        handleStatus(updateStatus, false, 0);
      },500);
    }else{
      const response = await fetch('/afas/fetchUpdates');
      if (response.ok) {
        const responseData = await response.json();
        
        if(responseData){
          updateStatus(responseData);

          if(responseData.length > 0 && responseData[responseData.length-1]["status"] == 1){
            setTimeout(function(){
              handleStatus(updateStatus, false);
            }, 750);
          }
        } 
      }
    }
  } catch(error) {
    setTimeout(function(){
      handleStatus(updateStatus, false);
    },500);
  }
  
}


